import {
  UTOPIA_CONTACT_EMAIL,
  UTOPIA_DISCORD_URL,
  UTOPIA_SITE_URL,
} from '../../utopia/constants'

export const UTOPIA_CGU_UPDATED = '21 mai 2026'

export type CguSection = {
  title: string
  paragraphs?: string[]
  bullets?: string[]
  subBullets?: string[]
}

export const UTOPIA_CGU_SECTIONS: CguSection[] = [
  {
    title: '1. Présentation du serveur',
    paragraphs: [
      'Le serveur Utopie Serveur est un serveur communautaire Minecraft accessible aux utilisateurs disposant :',
    ],
    bullets: [
      'd\'un exemplaire officiel du jeu Minecraft ;',
      'd\'un compte Microsoft/Mojang valide permettant de posséder Minecraft Java Edition ;',
      'd\'un compte interne « Utopie » créé via notre système d\'authentification.',
    ],
    subBullets: [
      'Le compte Utopie est indépendant du compte Microsoft.',
      'Un utilisateur peut créer un compte Utopie sans utiliser directement son compte Microsoft pour les services web et internes du serveur.',
      'Cependant, l\'accès au serveur Minecraft en jeu est soumis à la possession légale du jeu.',
    ],
  },
  {
    title: '2. Conditions d\'accès',
    paragraphs: ['Pour accéder au serveur, l\'utilisateur doit :'],
    bullets: [
      'posséder légalement Minecraft Java Edition ;',
      'disposer d\'un compte Microsoft/Mojang valide ;',
      'respecter les présentes CGU et les règles du serveur ;',
      'utiliser le serveur conformément à son fonctionnement prévu.',
    ],
    subBullets: [
      'L\'administration se réserve le droit de refuser, suspendre ou supprimer l\'accès à tout utilisateur ne respectant pas ces conditions.',
    ],
  },
  {
    title: '3. Comptes utilisateurs',
    paragraphs: ['Chaque utilisateur est responsable :'],
    bullets: [
      'de la sécurité de son compte Minecraft ;',
      'de la sécurité de son compte Utopie ;',
      'des actions effectuées depuis ses comptes.',
    ],
    subBullets: [
      'Le partage, la vente, le prêt ou la cession de compte sont strictement interdits sans autorisation de l\'administration.',
      'Toute tentative de contournement des systèmes d\'authentification ou d\'usurpation d\'identité pourra entraîner des sanctions immédiates.',
    ],
  },
  {
    title: '4. Règles concernant les versions du jeu',
    paragraphs: [
      'L\'utilisation de versions piratées (« crackées ») de Minecraft est strictement interdite.',
      'Toutefois, cette interdiction ne s\'applique pas si l\'utilisateur remplit les conditions suivantes :',
    ],
    bullets: [
      'il possède un compte Microsoft valide ;',
      'ce compte détient légalement Minecraft Java Edition.',
    ],
    subBullets: [
      'Dans ce cas, l\'utilisateur est considéré comme légitime et peut accéder au serveur conformément aux règles en vigueur.',
      'Toute tentative d\'accès frauduleux ou de contournement de la possession légale du jeu pourra entraîner un bannissement.',
    ],
  },
  {
    title: '5. Règles de conduite',
    paragraphs: ['Les utilisateurs s\'engagent à adopter un comportement respectueux et fair-play.', 'Sont interdits :'],
    bullets: [
      'insultes, harcèlement ou propos discriminatoires ;',
      'spam et publicité non autorisée ;',
      'grief volontaire ;',
      'exploitation de bugs ;',
      'triche ou utilisation de mods interdits ;',
      'contournement des systèmes de sécurité.',
    ],
    subBullets: [
      'Sont notamment considérés comme cheats interdits : X-Ray ; KillAura ; Fly ; duplication d\'objets ; auto-clickers abusifs.',
      'L\'administration se réserve le droit de sanctionner tout comportement nuisant à l\'expérience de jeu.',
    ],
  },
  {
    title: '6. Compte Utopie et authentification',
    paragraphs: [
      'Le serveur utilise un système de compte interne « Utopie » permettant :',
    ],
    bullets: [
      'la gestion des joueurs ;',
      'la sécurité des données ;',
      'la progression et les statistiques ;',
      'la liaison avec le compte Minecraft.',
    ],
    subBullets: [
      'Les données collectées peuvent inclure : pseudo Minecraft ; UUID ; adresse IP ; historique de connexion ; données de jeu.',
      'Ces données sont utilisées uniquement pour le fonctionnement du serveur et ne sont pas revendues.',
    ],
  },
  {
    title: '7. Protection des données',
    paragraphs: [
      'Les données personnelles sont traitées conformément au RGPD.',
      'L\'utilisateur peut demander : l\'accès à ses données ; leur modification ; leur suppression (dans les limites techniques et légales).',
      `Contact : ${UTOPIA_CONTACT_EMAIL}`,
    ],
  },
  {
    title: '8. Boutique et achats (si applicable)',
    paragraphs: ['Utopie Serveur peut proposer des contenus payants facultatifs :'],
    bullets: [
      'grades ;',
      'cosmétiques ;',
      'monnaies virtuelles ;',
      'avantages non essentiels au gameplay compétitif.',
    ],
    subBullets: [
      'Les achats sont définitifs sauf obligation légale contraire.',
      'Toute fraude ou chargeback pourra entraîner : suspension du compte ; bannissement définitif ; suppression des avantages obtenus.',
    ],
  },
  {
    title: '9. Disponibilité du service',
    paragraphs: [
      'Le serveur est fourni sans garantie de disponibilité continue.',
      'L\'administration peut : effectuer des maintenances ; modifier ou supprimer des fonctionnalités ; réinitialiser des données ; interrompre temporairement ou définitivement le service.',
      'Aucune compensation ne pourra être exigée en cas de perte de données ou d\'indisponibilité.',
    ],
  },
  {
    title: '10. Propriété intellectuelle',
    paragraphs: [
      'Tous les contenus du serveur (plugins, builds, logos, textes, systèmes, etc.) appartiennent à leurs créateurs respectifs.',
      'Toute reproduction non autorisée est interdite.',
      'Minecraft est une marque appartenant à Mojang Studios et à Microsoft.',
      'Utopie Serveur n\'est pas affilié à Mojang Studios ni à Microsoft.',
    ],
  },
  {
    title: '11. Sanctions',
    paragraphs: ['En cas de non-respect des CGU ou des règles du serveur, les sanctions peuvent inclure :'],
    bullets: [
      'avertissement ;',
      'mute ;',
      'kick ;',
      'suspension temporaire ;',
      'bannissement définitif ;',
      'suppression de données.',
    ],
    subBullets: ['Les sanctions sont appliquées selon la gravité des faits.'],
  },
  {
    title: '12. Modification des CGU',
    paragraphs: [
      'Les CGU peuvent être modifiées à tout moment.',
      'La poursuite de l\'utilisation du serveur implique l\'acceptation des modifications.',
    ],
  },
  {
    title: '13. Contact',
    paragraphs: [
      `E-mail : ${UTOPIA_CONTACT_EMAIL}`,
      `Discord : ${UTOPIA_DISCORD_URL}`,
      `Site web : ${UTOPIA_SITE_URL}`,
    ],
  },
  {
    title: '14. Acceptation',
    paragraphs: [
      'En accédant à Utopie Serveur, l\'utilisateur reconnaît avoir lu, compris et accepté les présentes Conditions Générales d\'Utilisation.',
    ],
  },
]
